import React from "react";
import { Button } from "@material-ui/core";
import useStyles from "./styles";
import { Typography } from "../Wrappers";

export default function PageTitle(props) {
  var classes = useStyles();

  return (
    <div
      className={classes.pageTitleContainer}
      style={{ position: "atatic", right: 420, zIndex: 999 }}
    >
      <Typography className={classes.typo} variant="h1" size="sm">
        {props.title}
      </Typography>
      <div style={{}}>
        {props.fourthButton && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onFourthClick}
            style={{ marginRight: 10, fontFamily: "Pathway Gothic One" }}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.fourthButton}
          </Button>
        )}

        {props.thirdButton && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onThirdClick}
            style={{ marginRight: 10, fontFamily: "Pathway Gothic One" }}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.thirdButton}
          </Button>
        )}
        {props.secondButton && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onSecondClick}
            style={{ marginRight: 10, fontFamily: "Pathway Gothic One" }}
            variant="contained"
            size="large"
            color="secondary"
          >
            {props.secondButton}
          </Button>
        )}
        {props.button && (
          <Button
            classes={{ root: classes.button }}
            onClick={props.onClick}
            style={{
              marginRight: 10,
              fontFamily: "Pathway Gothic One",
              ...(props.buttonColor && {
                backgroundColor: props.buttonColor,
                color: "white",
              }),
            }}
            variant="contained"
            size="large"
            color={props.buttonColor ? undefined : "secondary"}
          >
            {props.button}
          </Button>
        )}
      </div>
    </div>
  );
}
